var map = {
	"./angular.svg": 7611,
	"./aws.svg": 9277,
	"./css.svg": 8136,
	"./git.svg": 4513,
	"./github.svg": 4118,
	"./html.svg": 8952,
	"./java.svg": 4615,
	"./javascript.svg": 1614,
	"./jenkins.svg": 4243,
	"./ms-sql-server.svg": 8804,
	"./mysql.svg": 6319,
	"./net.svg": 6528,
	"./python.svg": 9069,
	"./spring.svg": 8340,
	"./vue.svg": 2665,
	"./wordpress.svg": 9956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7487;